import { createSlice } from '@reduxjs/toolkit'

export const TaskTypeSelected = createSlice({
  name: 'task_selected',
  initialState: {
    value : ['ALL', 'All']
  },
  reducers: {
    selectedTask: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { selectedTask } = TaskTypeSelected.actions

export default TaskTypeSelected.reducer